import {useCallback,useEffect,useState} from 'react';

function isStandaloneMode() {
  return window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;
}

function isIosSafari() {
  const userAgent=window.navigator.userAgent;
  const ios=/iPad|iPhone|iPod/.test(userAgent);
  const safari=/Safari/.test(userAgent);
  const excluded=/CriOS|FxiOS|OPiOS|EdgiOS/.test(userAgent);
  return ios && safari && !excluded;
}

export default function usePwaInstall() {
  const [deferredPrompt,setDeferredPrompt]=useState(null);
  const [iosSafari,setIosSafari]=useState(false);
  const [isInstalled,setIsInstalled]=useState(false);

  useEffect(()=> {
    setIosSafari(isIosSafari());
    setIsInstalled(
      localStorage.getItem('pwa_installed')==='true' || isStandaloneMode(),
    );

    const handleBeforeInstallPrompt=(event)=> {
      event.preventDefault();
      setDeferredPrompt(event);
    };

    const handleAppInstalled=()=> {
      localStorage.setItem('pwa_installed','true');
      setDeferredPrompt(null);
      setIsInstalled(true);
    };

    window.addEventListener('beforeinstallprompt',handleBeforeInstallPrompt);
    window.addEventListener('appinstalled',handleAppInstalled);

    return ()=> {
      window.removeEventListener('beforeinstallprompt',handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled',handleAppInstalled);
    };
  },[]);

  const installApp=useCallback(async()=> {
    if (!deferredPrompt) return false;

    await deferredPrompt.prompt();
    const {outcome}=await deferredPrompt.userChoice;
    setDeferredPrompt(null);

    if (outcome==='accepted') {
      localStorage.setItem('pwa_installed','true');
      setIsInstalled(true);
      return true;
    }

    return false;
  },[deferredPrompt]);

  const canShowPwaCallout=useCallback(()=> {
    return localStorage.getItem('pwa_installed')!=='true' &&
      localStorage.getItem('pwa_prompt_shown')!=='true' &&
      !isStandaloneMode();
  },[]);

  return {
    deferredPrompt,
    installApp,
    iosSafari,
    isInstalled,
    canShowPwaCallout,
  };
}